<div class="bi">
	<router-outlet>
	</router-outlet>
</div>